import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { activeTabSelector } from '@store/policies/schedule/selectors';
import { scheduleViewTabs , policyAction } from '@store/policies/schedule/utils';
import ViewAllSchedulesButton from './ViewAllSchedulesButton';
import { ScheduleListWrapper } from './styled';
import TopBar from './TopBar';
import Table from './Table';
import Calendar from './Calender';
import { Tabs } from 'antd';

function ScheduleList({ canEdit }) {
  const activeTab = useSelector(activeTabSelector);

  const [selectedTab, setSelectedTab] = useState(policyAction.activate);

  const tabItems = [
    {
      key: policyAction.activate,
      label: 'Policy Activation',
      children: <Table canEdit={canEdit} type={policyAction.activate} />,
    },
    {
      key: policyAction.reorder,
      label: 'Policy Reorder',
      children: <Table canEdit={canEdit} type={policyAction.reorder} />,
    },
  ];

  const onChange = (key: string) => {
    setSelectedTab(selectedTab);
  };

  // the table is always rendered on first load
  return (
    <ScheduleListWrapper>
      <TopBar />
      {activeTab === scheduleViewTabs.calender ? (
        <Calendar canEdit={canEdit} />
      ) : (
        <Tabs
          defaultActiveKey={policyAction.activate}
          value={selectedTab}
          items={tabItems}
          onChange={onChange}
        />
      )}
    </ScheduleListWrapper>
  );
}

export default ScheduleList;
export { ViewAllSchedulesButton };
